import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import '../../TargetReport/TableContent/index.css';
import './operations.css';
import { Height } from '@material-ui/icons';
import { ListItemText, TableFooter, Tooltip, Typography } from '@material-ui/core';
import { monthNumberToString } from '../../../../utils/monthStringToNumber'

function TableContent({ 
  tableData,
  totalizarColuna,
  totalizadorColunaMedia,
  totalizadorColunaSoma,
  totalizadorLinhaColunaMedia,
  totalizadorLinhaColunaSoma,
  informacao }) {
  const [propertySorted, setPropertySorted] = useState({});
  const [bodyTable, setBodyTable] = useState();
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatItens = (e) => {
    if (informacao.toLowerCase() === 'volume' || informacao.toLowerCase() === 'receita'|| informacao.toLowerCase() === 'comissionamentocapittale') {
      return (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
            <span>R$</span>
            <span>{e ? formatter.format(e) : '0,00'}</span>
          </div>
        </>
      );
    } else if (informacao.toLowerCase() === 'taxa' || informacao.toLowerCase() === 'desagio') {
      return (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
            <span></span>
            <span>{e ? parseFloat(e).toFixed(2) + '%' : '0.00%'}</span>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
            <span></span>
            <span>{e ? e : '0'}</span>
          </div>
        </>
      );
    }
  };

  const dataFooter = totalizarColuna?.map(function (item, index) {
    return (
      <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="right">
        {formatItens(item.valorInformacao)}
      </TableCell>
    );
  });

  const dateHeaderColumn = totalizarColuna?.map(function (item, index) {
    return (
      <>
        <TableCell
          style={{ color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
          key={item.ancoraId}
          align="center"
          onClick={() => sortTable(index, 'info')}
        >
          {`${monthNumberToString(item.mes)} ${item.ano}`}
        </TableCell>
      </>
    );
  });

  const setTable = (data) => {
    localStorage.setItem('startRow', 1);
    setBodyTable(
      data.map(function (item, index) {
        let backColor = 'white';
        if (index % 2) {
          backColor = '#EEEEEE';
        }
        let indexSoma = totalizadorLinhaColunaSoma.findIndex(x => x.ancoraId === item.ancoraId)
        let indexMedia = totalizadorLinhaColunaMedia.findIndex(x => x.ancoraId === item.ancoraId)
        return (
          <>
            <TableRow key={item.index} style={{ backgroundColor: backColor }}>
              <TableCell align="left" className='fixed-column' style={{ backgroundColor: backColor }}>{item.rede}</TableCell>
              {item.detalhes?.map((detalhe, detalheIndex) => {
                  return (
                    <TableCell align="right">
                      {formatItens(detalhe.valorInformacao)}
                    </TableCell>
                  );
                })}
                <TableCell align="left">{formatItens(totalizadorLinhaColunaSoma[indexSoma]?.valorInformacao)}</TableCell>
                <TableCell align="left">{formatItens(totalizadorLinhaColunaMedia[indexMedia]?.valorInformacao)}</TableCell>
            </TableRow>
          </>
        )
      })
    )
  }

  const sortTable = (param, tipo) => {
    if (tipo === 'soma') {
      const orderedArraySoma = totalizadorLinhaColunaSoma.sort(dynamicSort(param, tipo))
      let arrayTable = [];
      orderedArraySoma.map((soma) => {
        const itemData = tableData.find(x => x.ancoraId === soma.ancoraId)
        arrayTable.push(itemData)
      });
      setTable(arrayTable);
    } else if (tipo === 'media') {
      const orderedArrayMedia = totalizadorLinhaColunaMedia.sort(dynamicSort(param, tipo))
      let arrayTable = [];
      orderedArrayMedia.map((soma) => {
        const itemData = tableData.find(x => x.ancoraId === soma.ancoraId)
        arrayTable.push(itemData)
      });
      setTable(arrayTable);
    } else {
      setTable(tableData.sort(dynamicSort(param, tipo)));
    }
  };

  function dynamicSort(property, tipo) {
    let sortOrder = 1;
    switch (tipo) {
      case 'rede':
        if (propertySorted[property] !== undefined) {
          sortOrder = propertySorted[property] * -1;
        }
        setPropertySorted((properties) => ({ ...properties, [property]: sortOrder }));
        return function (a, b) {
          const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      case 'info':
        if (propertySorted.detalhes !== undefined) {
          sortOrder = propertySorted.detalhes * -1;
        }
        setPropertySorted((properties) => ({ ...properties, detalhes: sortOrder }));
        return function (a, b) {
          const result = a.detalhes[property]?.valorInformacao < b.detalhes[property]?.valorInformacao ? 
          -1 : a.detalhes[property]?.valorInformacao > b.detalhes[property]?.valorInformacao ? 1 : 0;
          return result * sortOrder;
        };
      case 'soma':
        if (propertySorted[property] !== undefined) {
          sortOrder = propertySorted[property] * -1;
        }
        setPropertySorted((properties) => ({ ...properties, [property]: sortOrder }));
        return function (a, b) {
          const result = a.valorInformacao < b.valorInformacao  ?
          -1 : a.valorInformacao  > b.valorInformacao  ? 1 : 0;
          return result * sortOrder;
        };
      case 'media':
        if (propertySorted[property] !== undefined) {
          sortOrder = propertySorted[property] * -1;
        }
        setPropertySorted((properties) => ({ ...properties, [property]: sortOrder }));
        return function (a, b) {
          const result = a.valorInformacao < b.valorInformacao  ?
          -1 : a.valorInformacao  > b.valorInformacao  ? 1 : 0;
          return result * sortOrder;
        };
    }
  }

  useEffect(() => {
    if (tableData) {
      setTable(tableData);;
    }
  }, [tableData]);

  return (
    <>
      <div
        className="report-tables"
        style={{
          margin: '0px 45px 0px 50px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
          flexWrap: 'wrap',
          display: 'flex',
          overflowX: 'auto',
        }}
      >
        <Table
          style={{
            backgroundColor: 'white',
            marginBottom: '20px',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: '#232C63' }}>
            <TableRow>
              <TableCell
              style={{ color: 'white', fontWeight: 'bold', cursor: 'pointer', backgroundColor: '#232C63' }}
              align="center"
              className='fixed-column'
              onClick={() => sortTable('rede', 'rede')}>
                Rede
              </TableCell>
              {dateHeaderColumn}
              <TableCell style={{ color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
              align="center"
              onClick={() => sortTable('soma', 'soma')}>
                Soma
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
              align="center"
              onClick={() => sortTable('media', 'media')}>
                Média
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bodyTable}
            <TableRow>
              <TableCell className='fixed-column' style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                Total
              </TableCell>
              {dataFooter}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatItens(totalizadorColunaSoma.valorInformacao)}
              </TableCell>
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatItens(totalizadorColunaMedia.valorInformacao)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div
        style={{
          marginTop: '20px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
        }}
      ></div>
    </>
  );
}

export default TableContent;
